import moment from "moment";
import React, { useEffect, useState } from "react";
import { InputLabel } from "@mui/material";
import { Card, CardBody, Col, Row } from "reactstrap";

import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import { isFilterApplied } from "views/pages/manage/edpOps/constant/batch-search";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";

import { DEFAULT_FILTERS, InputLabelStyle, UPLOAD_STATUS } from "./constants";

const Filters = ({
  closeForm,
  globalFilter,
  setGlobalFilter,
  filterCount,
  setFilterCount,
  searchHandler,
}) => {
  const [filterForm, setFilterForm] = useState(DEFAULT_FILTERS);

  useEffect(() => {
    setFilterForm({
      ...globalFilter,
      status: UPLOAD_STATUS.filter((obj) =>
        globalFilter?.status.includes(obj.value)
      ),
    });
  }, []);

  const filterFormHandler = (key, value) => {
    setFilterForm((prev) => ({ ...prev, [key]: value }));
  };

  const applyFilter = () => {
    closeForm();

    const filterCount = isFilterApplied({
      ...filterForm,
    });
    setFilterCount(filterCount);

    const payload = {
      ...globalFilter,
      ...(filterForm.status.length
        ? {
            status: filterForm.status.map((selected) => selected.value),
          }
        : { status: [] }),
      ...(filterForm.fromDate && {
        fromDate: new Date(filterForm.fromDate).toISOString(),
      }),
      ...(filterForm.toDate && {
        toDate: new Date(moment(filterForm.toDate).endOf("day")).toISOString(),
      }),
    };

    setGlobalFilter(payload);
    searchHandler(payload);
  };

  const removeFilter = () => {
    closeForm();
    setFilterForm(DEFAULT_FILTERS);
    setGlobalFilter(DEFAULT_FILTERS);
    searchHandler(DEFAULT_FILTERS);

    setFilterCount(0);
  };

  return (
    <Card
      className="mb-0 regular-body label-color"
      style={{ width: "330px", borderRadius: "12px" }}
    >
      <CardBody className="d-flex flex-column">
        <div className="text-bold text-lg mb-2">Filters</div>

        <div className="d-flex flex-column gap-md">
          <AAutoComplete
            label="Status"
            placeholder="Select to add"
            items={UPLOAD_STATUS}
            currentValue={filterForm?.status}
            isShowCount={true}
            handleChange={(value) => {
              filterFormHandler("status", value);
            }}
            inputKey=""
          />

          <InputLabel style={InputLabelStyle}>Processing Date</InputLabel>
          <Row>
            <Col sm="6">
              <CustomDatePickerV2
                placeHolder="From"
                maxDate={moment(new Date())}
                value={filterForm?.fromDate}
                width={"18px"}
                handler={(index, date, keyName) => {
                  filterFormHandler("fromDate", date);
                }}
              />
            </Col>
            <Col sm="6">
              <CustomDatePickerV2
                placeHolder="To"
                width={"18px"}
                maxDate={moment(new Date())}
                minDate={filterForm?.fromDate}
                value={filterForm?.toDate}
                handler={(index, date, keyName) => {
                  filterFormHandler("toDate", date);
                }}
                disabled={!filterForm?.fromDate}
              />
            </Col>
          </Row>

          <div
            className={"mt-3 d-flex flex-row-reverse justify-content-between"}
          >
            <AButton
              variant="primary_filled"
              className="w-full ml-0"
              onClick={applyFilter}
              disabled={""}
              updatedStyle={filterCount > 0 ? "" : { width: "100%" }}
            >
              Apply filter
            </AButton>

            {filterCount > 0 && (
              <AButton
                variant="outline"
                className="button_remove_left_margin"
                updatedStyle={{ border: "1px solid #CC5F5F", color: "#CC5F5F" }}
                onClick={removeFilter}
              >
                Remove filter
              </AButton>
            )}
          </div>
        </div>
      </CardBody>
    </Card>
  );
};

export default Filters;
